import { Component, OnInit } from "@angular/core";
import { MDBModalRef } from "angular-bootstrap-md";
import {
  InstaCitiCountries,
  InstacitiSupport,
} from "../instaciti-new.interface";
import { InstacitiNewService } from "../service/instaciti-new.service";

@Component({
  selector: "app-instaciti-support",
  templateUrl: "./instaciti-support.component.html",
  styleUrls: ["./instaciti-support.component.css"],
})
export class InstacitiSupportComponent implements OnInit {
  SupportList: InstacitiSupport[] = [];
  CountriesList: InstaCitiCountries[] = [];
  filteredCountries: InstaCitiCountries[] = [];
  SelectedCountryID: number;
  SelectedCountry: string;
  constructor(
    private service: InstacitiNewService,
    public modalRef: MDBModalRef
  ) {}

  ngOnInit() {

    let country = this.CountriesList.find(item=>item.CountryID == this.SelectedCountryID)
    
    this.PopulateSupportList(country?.CountryName);
  }
  closeDialog() {
    this.modalRef.hide();
  }

  PopulateSupportList(countryID) {
    let portalds = "INSTA-IN";
    this.filteredCountries= this.CountriesList
    console.log(countryID);
    
    this.SelectedCountry = this.CountriesList.find(item=>item.CountryName == countryID).CountryName
    console.log("zxcv",this.SelectedCountry);
    
    let contID = this.CountriesList.find(item=>item.CountryName == countryID).CountryID
    console.log("zxcv",contID);

    this.filteredCountries= this.CountriesList
    let prtal= this.CountriesList.find((element) => element.CountryID == contID)
      portalds = prtal.CountryDBContext;
      
    this.filteredCountries = this.CountriesList
    sessionStorage.setItem("PortalDS", portalds);
    this.service.onCountryChange(contID).subscribe((res) => {
      this.SupportList = res.ManikJSon[0].JSon0;
    });
  }
  filterCountries(e){
    this.filteredCountries = this.CountriesList.filter(data=>data.CountryName.toLowerCase().includes(e.target.value.toLowerCase()))
  }
}
